<template>
    <div class="px-sm-0 px-2">
        <v-card flat tile>
            <v-card-text>
        <v-btn block :loading="loading" :disabled="loading" color="primary" depressed tile large @click="submit($event)">Dokončit objednávku</v-btn>
        <p class="caption mt-2">Dokončením objednávky potvrzujete, že jste se seznámil s  <a
                target="_blank"
                href="/pdf/Prazskyportal_Obchodni podminky_14052020 .pdf"
                @click.stop
        >Obchodními podmínkami</a>.</p>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: 'PlaceOrder',
        props: ['form', 'loading'],
        data () {
            return {
                rules: window.validationRules.getRules()
            }
        },
        methods: {
            submit(event) {
                this.$emit('submit', event);
            }
        }
    }
</script>
